/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { dropdownTitleToFeaturePageMap } from "components/header/constants";
import { ReactComponent as RightArrow } from "cms/assets/icons/arrow-right.svg";

const DropdownFeaturePage = (props) => {

    const menuTitle = props?.menuTitle ?? "";
    const featurePageData = dropdownTitleToFeaturePageMap[menuTitle];
    const featurePageClass = featurePageData?.className ?? "";
    const description = featurePageData?.featurePageDescription ?? "";
    const pageTitle = featurePageData?.featurePageTitle ?? "";
    const pageUrl = featurePageData?.featurePageUrl ?? "";

    return (
        <a href={pageUrl} className='dropdown-feature-page'>
            <div className='dropdown-image-container'>
                <div className={`dropdown-image ${featurePageClass}`}></div>
            </div>
            <div className='dropdown-feature-text'>
                <span className='feature-page-title'>{pageTitle} <RightArrow /></span>
                <span>{description}</span>
            </div>
        </a>
    );
};

export { DropdownFeaturePage };
